export default __webpack_public_path__ + "static/1319-147b3a1d0d5a4431842ad6279729ecd6.gif";